import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index";
import Search from "@views/shop/GoodSearch";
import Category from "@views/shop/GoodsClass";
import ShoppingCart from "@views/shop/ShoppingCart";
import GoodsList from "@views/shop/GoodsList";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Loading from "@views/Loading";

Vue.use(Router);
let routes = [
  {
    path: "/",
    name: "Index",
    meta: {
      title: "首页",
      keepAlive: true,
      // footer: true,
      backgroundColor: "#fff",
    },
    component: Index,
  },
  {
    path: "/customer/chat/:id/:productId?",
    name: "CustomerService",
    meta: {
      title: "客服聊天",
      keepAlive: false,
      auth: true,
    },
    component: () => import("@views/user/CustomerService.vue"),
  },
  {
    path: "/category/:pid?",
    name: "GoodsClass",
    meta: {
      title: "产品分类",
      keepAlive: true,
      // footer: true,
      backgroundColor: "#fff",
    },
    component: Category,
  },
  {
    path: "/collection",
    name: "GoodsCollection",
    meta: {
      title: "收藏商品",
      keepAlive: false,
      auth: true,
    },
    component: () => import("@views/shop/GoodsCollection.vue"),
  },
  {
    path: "/search",
    name: "GoodSearch",
    meta: {
      title: "搜索商品",
      keepAlive: true,
      backgroundColor: "#fff",
    },
    component: Search,
  },
  {
    path: "/news_detail/:id",
    name: "NewsDetail",
    meta: {
      title: "新闻详情",
      keepAlive: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/shop/news/NewsDetail.vue"),
  },
  {
    path: "/news_list",
    name: "NewsList",
    meta: {
      title: "新闻",
      keepAlive: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/shop/news/NewsList.vue"),
  },
  {
    path: "/evaluate_list/:id",
    name: "EvaluateList",
    meta: {
      title: "商品评分",
      keepAlive: true,
      auth: true,
    },
    component: () => import("@views/shop/EvaluateList.vue"),
  },
  {
    path: "/goods_evaluate/:id",
    name: "GoodsEvaluate",
    meta: {
      title: "商品评价",
      keepAlive: true,
      auth: true,
    },
    component: () => import("@views/shop/GoodsEvaluate.vue"),
  },
  {
    path: "/promotion",
    name: "GoodsPromotion",
    meta: {
      title: "促销单品",
      keepAlive: false,
    },
    component: () => import("@views/shop/GoodsPromotion.vue"),
  },
  {
    path: "/hot_new_goods/:type",
    name: "HotNewGoods",
    meta: {
      title: "热门榜单",
      keepAlive: false,
    },
    component: () => import("@views/shop/HotNewGoods.vue"),
  },
  {
    path: "/detail/:id",
    name: "GoodsCon",
    meta: {
      title: "商品详情",
      keepAlive: false,
    },
    component: () => import("@views/shop/GoodsCon.vue"),
  },
  {
    path: "/shop/storeList/:gonames?",
    name: "StoreList",
    meta: {
      title: "门店列表",
      keepAlive: false,
    },
    component: () => import("@views/shop/StoreList.vue"),
  },
  {
    path: "/cart",
    name: "ShoppingCart",
    meta: {
      title: "购物车",
      keepAlive: true,
      // footer: true,
      // auth: true
    },
    component: ShoppingCart,
  },
  {
    path: "/goods_list",
    name: "GoodsList",
    meta: {
      title: "商品列表",
      keepAlive: true,
    },
    component: GoodsList,
  },
  {
    path: "/user",
    name: "user",
    meta: {
      title: "我的",
      keepAlive: true,
      // footer:true
    },
    component: () => import("@views/user/User.vue"),
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      title: "注册",
      keepAlive: true,
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@views/user/Register.vue"),
  },
  {
    path: "/change_password",
    name: "ChangePassword",
    meta: {
      title: "修改密码",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@views/user/ChangePassword.vue"),
  },
  {
    path: "/retrieve_password",
    name: "RetrievePassword",
    meta: {
      title: "找回密码",
      keepAlive: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "login" */ "@views/user/RetrievePassword.vue"
      ),
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登录",
      keepAlive: true,
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@views/user/Login.vue"),
  },
  ...module,
  {
    path: "/auth",
    name: "Loading",
    meta: {
      title: " 加载中",
      keepAlive: true,
    },
    component: Loading,
  },
  {
    path: "*",
    name: "NotDefined",
    meta: {
      title: "页面找不到",
      keepAlive: true,
      home: false,
      backgroundColor: "#F4F6FB",
    },
    component: NotDefined,
  },
  // 食堂支付
  {
    path: "/payment",
    name: "payment",
    meta: {
      title: "食堂支付",
      keepAlive: true,
    },
    component: () => import("@views/user/payment/index.vue"),
  },
  // 食堂支付成功
  {
    path: "/succeedST",
    name: "succeedST",
    meta: {
      title: "食堂支付状态",
      keepAlive: true,
    },
    component: () => import("@views/user/payment/succeed.vue"),
  },// 咖啡
  {
    path: "/coffee",
    name: "coffee",
    meta: {
      title: "咖啡支付",
      keepAlive: true,
    },
    component: () => import("@views/user/CoffeePayment/index.vue"),
  },
  // 线下京东订购，
  {
    path: "/offlinejdordering",
    name: "offlinejdordering",
    meta: {
      title: "京东订购",
      keepAlive: true,
    },
    component: () => import("@views/user/directPayment/offlinejdordering.vue"),
  },
  // 线下商品订购
  {
    path: "/offlineproordering",
    name: "offlineproordering",
    meta: {
      title: "商品",
      keepAlive: true,
    },
    component: () => import("@views/user/directPayment/offlineproordering.vue"),
  },
  // 线下商品支付状态
  {
    path: "/directPaymentSucceed",
    name: "directPaymentSucceed",
    meta: {
      title: "支付状态",
      keepAlive: true,
    },
    component: () => import("@views/user/directPayment/succeed.vue"),
  },
  // 咖啡支付成功
  {
    path: "/succeedCoffee",
    name: "succeedCoffee",
    meta: {
      title: "咖啡支付状态",
      keepAlive: true,
    },
    component: () => import("@views/user/CoffeePayment/succeed.vue"),
  },
  // 报修
  {
    path: "/repairs",
    name: "repairs",
    meta: {
      title: "报修/保洁",
      keepAlive: true,
    },
    component: () => import("@views/user/repairs/index.vue"),
  },// 投递简历
  {
    path: "/personnel",
    name: "personnel",
    meta: {
      title: "投递简历",
      keepAlive: true,
    },
    component: () => import("@views/user/personnel/personnel.vue"),
  },
  // 抢单==派单
  {
    path: "/rob",
    name: "rob",
    meta: {
      title: "派单",
      keepAlive: true,
    },
    component: () => import("@views/user/rob/index.vue"),
  },//我的派单
  {
    path: "/myrob",
    name: "myrob",
    meta: {
      title: "我的派单",
      keepAlive: true,
    },
    component: () => import("@views/user/myrob/index.vue"),
  },
  // 订单进度
  {
    path: "/schedule",
    name: "schedule",
    meta: {
      title: "订单进度",
      keepAlive: true,
    },
    component: () => import("@views/user/schedule/index.vue"),
  },
  // 评价
  {
    path: "/evaluate/:id",
    name: "evaluate",
    meta: {
      title: "订单评价",
      keepAlive: true,
    },
    component: () => import("@views/user/evaluate/index.vue"),
  },
  // 报修记录
  {
    path: "/record/:type",
    name: "record",
    meta: {
      title: "报修/保洁记录",
      keepAlive: true,
    },
    component: () => import("@views/user/record/index.vue"),
  },
  // 维修记录
  {
    path: "/maintain/:type",
    name: "maintain",
    meta: {
      title: "报修/保洁记录",
      keepAlive: true,
    },
    component: () => import("@views/user/maintain/index.vue"),
  },
  // 员工卡使用
  {
    path: "/use",
    name: "use",
    meta: {
      title: "员工卡使用",
      keepAlive: true,
    },
    component: () => import("@views/user/use/index.vue"),
  },
  // 经理卡分配
  {
    path: "/manager",
    name: "manager",
    meta: {
      title: "工卡分配",
      keepAlive: true,
    },
    component: () => import("@views/user/manager/index.vue"),
  },
  // 工卡管理
  {
    path: "/administer",
    name: "administer",
    meta: {
      title: "工卡管理",
      keepAlive: true,
    },
    component: () => import("@views/user/administer/index.vue"),
  },
  // 班车
  {
    path: "/buspayment",
    name: "buspayment",
    meta: {
      title: "班车支付",
      keepAlive: true,
    },
    component: () => import("@views/user/buspayment/index.vue"),
  },
  // 班车支付成功
  {
    path: "/succeed",
    name: "succeed",
    meta: {
      title: "班车支付状态",
      keepAlive: true,
    },
    component: () => import("@views/user/buspayment/succeed.vue"),
  },
  // 班车 小班车
  {
    path: "/buspaymentsamll",
    name: "buspaymentsamll",
    meta: {
      title: "班车支付",
      keepAlive: true,
    },
    component: () => import("@views/user/buspaymentsamll/index.vue"),
  },
  // 班车支付成功 小班车
  {
    path: "/succeedsamllcar",
    name: "succeed",
    meta: {
      title: "班车支付状态",
      keepAlive: true,
    },
    component: () => import("@views/user/buspaymentsamll/succeed.vue"),
  },
  // 自动售卖机
  {
    path: "/autosale",
    name: "autosale",
    meta: {
      title: "自动售卖机支付",
      keepAlive: true,
    },
    component: () => import("@views/user/autosale/index.vue"),
  },
  // 自动售卖机支付成功
  {
    path: "/autosaleSucceed",
    name: "autosalesucceed",
    meta: {
      title: "自动售卖机支付状态",
      keepAlive: true,
    },
    component: () => import("@views/user/autosale/succeed.vue"),
  },
  // 支付码
  {
    path: "/payYard",
    name: "payYard",
    meta: {
      title: "支付码",
      keepAlive: true,
    },
    component: () => import("@views/user/payYard/index.vue"),
  }, // 公卡码
  {
    path: "/publiCard",
    name: "publiCard",
    meta: {
      title: "公卡码",
      keepAlive: true,
    },
    component: () => import("@views/user/publiCard/index.vue"),
  },// 班车支付
  {
    path: "/busPay",
    name: "busPay",
    meta: {
      title: "班车支付",
      keepAlive: true,
    },
    component: () => import("@views/user/busPay/index.vue"),
  },
  // 我的卡
  {
    path: "/block",
    name: "block",
    meta: {
      title: "我的工卡",
      keepAlive: true,
    },
    component: () => import("@views/user/block/index.vue"),
  },
  // 班车券使用记录
  {
    path: "/usage",
    name: "usage",
    meta: {
      title: "使用记录",
      keepAlive: true,
    },
    component: () => import("@views/user/usage/index.vue"),
  },
];
const router = new Router({
  mode: "history",
  routes,
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  },
});

const { back, replace } = router;

router.back = function () {
  this.isBack = true;
  back.call(router);
};
router.replace = function (...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  const { title, backgroundColor, footer, home, auth } = to.meta;
  // document.title = title || process.env.VUE_APP_NAME || "crmeb商城";
  document.title = title || process.env.VUE_APP_NAME || "商城";
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});
export { routes };
export default router;
